import React, { createContext, useCallback, useContext, useState } from 'react';
import FeedbackDialog, { FeedbackType } from '../components/FeedbackDialog';

export interface FeedbackContent {
  type: FeedbackType;
  description?: string;
  closeTimeout?: number;
  title?: string;
  loading?: boolean;
  onClose?: () => void;
}

interface FeedbackContextDTO {
  addFeedback(message: FeedbackContent): void;
}

const FeedbackContext = createContext<FeedbackContextDTO>(
  {} as FeedbackContextDTO,
);

const FeedbackProvider: React.FC = ({ children }) => {
  const [message, setMessage] = useState<FeedbackContent>(
    {} as FeedbackContent,
  );

  const addFeedback = useCallback((content: FeedbackContent) => {
    setMessage(content);
  }, []);

  return (
    <FeedbackContext.Provider value={{ addFeedback }}>
      {children}
      <FeedbackDialog message={message} />
    </FeedbackContext.Provider>
  );
};

function useFeedback(): FeedbackContextDTO {
  return useContext(FeedbackContext);
}

export { FeedbackProvider, useFeedback };
